(function () {
  function updateBounds(mount) {
    var track = mount.querySelector('.flying-decor-track');
    if (!track) {
      return;
    }
    var width = mount.clientWidth;
    var height = mount.clientHeight;
    var trackWidth = track.offsetWidth;
    var trackHeight = track.offsetHeight;
    if (width <= 0 || height <= 0 || trackWidth <= 0 || trackHeight <= 0) {
      return;
    }
    var rangeWidth = Math.max(0, width - trackWidth);
    var rangeHeight = Math.max(0, height - trackHeight);
    mount.style.setProperty('--flying-bounds-w', width + 'px');
    mount.style.setProperty('--flying-bounds-h', height + 'px');
    mount.style.setProperty('--flying-track-w', trackWidth + 'px');
    mount.style.setProperty('--flying-track-h', trackHeight + 'px');
    mount.style.setProperty('--flying-range-w', rangeWidth + 'px');
    mount.style.setProperty('--flying-range-h', rangeHeight + 'px');
  }

  function initMount(mount) {
    if (!mount || !mount.classList.contains('flying-decor-layer')) {
      return;
    }
    updateBounds(mount);
    var track = mount.querySelector('.flying-decor-track');
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(function () {
        updateBounds(mount);
      });
      observer.observe(mount);
      if (track) {
        observer.observe(track);
      }
    } else {
      window.addEventListener(
        'resize',
        function () {
          updateBounds(mount);
        },
        { passive: true }
      );
    }
    if (track) {
      var flyingImg = track.querySelector('img');
      if (flyingImg && !flyingImg.complete) {
        flyingImg.addEventListener(
          'load',
          function () {
            updateBounds(mount);
          },
          { once: true }
        );
      }
    }
    var host = mount.parentElement;
    if (host) {
      host.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener(
            'load',
            function () {
              updateBounds(mount);
            },
            { once: true }
          );
        }
      });
    }
  }

  window.$s = window.$s || {};
  window.$s.initFlyingDecorSection = function (mountId) {
    var mount = document.getElementById(mountId);
    if (!mount) {
      return;
    }
    initMount(mount);
    requestAnimationFrame(function () {
      updateBounds(mount);
    });
  };
})();
